{
  "mailSubject": "Payment problem — Baby Plan",
  "help": "Write to support",
  "backToApp": "Back to Baby Plan",
  "failed": {
    "title": "Your payment didn't go through",
    "titleNamed": "{{name}}, your payment didn't go through",
    "lead": "Your bank declined the last payment for Baby Plan. Update your card and the payment will be retried automatically.",
    "subscription": "Subscription",
    "amount": "Amount",
    "attempted": "Tried on",
    "updateCard": "Update your card",
    "updateNote": "This opens Whop, where your Baby Plan subscription is billed. Sign in with the email you used to buy Baby Plan.",
    "keepTrying": "Your access stays on for a few days while we try again.",
    "keepTryingUntil": "Your access stays on until {{date}} while we try again.",
    "payNew": "Pay with another card"
  },
  "ended": {
    "title": "Your Baby Plan subscription has ended",
    "titleNamed": "{{name}}, your Baby Plan subscription has ended",
    "lead": "We couldn't take the payment, so your subscription is no longer active. Your baby's logs are safe and will be there when you come back.",
    "startAgain": "Start Baby Plan again",
    "sameEmail": "Use the same email as before so your logs come back with you."
  },
  "resolved": {
    "title": "All set",
    "lead": "Your payment is fine. Taking you to Baby Plan…"
  },
  "invalid": {
    "title": "This link has expired",
    "lead": "Payment links work for a limited time. If you got an email about a payment problem, write to {{email}} and we'll sort it out."
  }
}
